// extracted by mini-css-extract-plugin
export var errorIcon = "_p6-1";
export var nameLogo = "_p6-0";